<template>
    <div class="vx-card px-6 py-2">
        <div class="vx-row">
          
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label">Phòng ban</label>
                <v-select v-model="selectedDepartment" :options="departmentOptions" name="department" :clearable="false"
                    class="elipsisText">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 w-1/2  sm:mt-2 mt-2">
                <vs-button class="md:mt-4 sm:mt-2" color="primary" iconPack="feather" icon="icon-search"
                    @click="searchBooking">Tìm
                    kiếm
                </vs-button>
            </div>
            <!--            <div class="vx-col lg:w-1/4 md:w-2/3 w-1/2 lg:mt-4 sm:mt-2 mt-4">-->
            <!--                <vs-button class="md:mt-4 sm:mt-2 float-right" color="primary"-->
            <!--                           iconPack="feather" icon="icon-plus" @click="$router.push(`/user/booking-schedule-info`)"-->
            <!--                           v-if="isPermissionCreateBooking">-->
            <!--                    Tạo mới lịch hẹn-->
            <!--                </vs-button>-->
            <!--            </div>-->
        </div>

        <vs-table class="table-custom mt-6" :data="beautyBookingData" stripe >
            <template slot="thead">
                <vs-th>
                    STT
                </vs-th>
                <vs-th style="width: 200px;">
                    <div>
                        <label>Chi nhánh</label>
                        <v-select v-model="selectedBranch" :options="branchOptions" name="branch" :clearable="false" style="width: 200px;" @input="searchBooking">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Bác sĩ</label>
                        <v-select v-model="selectedDoctor" :options="doctorOptions" name="doctor" :clearable="false" @input="searchBooking">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Nhóm dịch vụ</label>
                        <v-select v-model="beautyServicePackageId" :options="groupServiceOptions" name="status" :reduce="item => item.value" :clearable="false" style="width: 200px;" @input="searchBooking"></v-select>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Trạng thái</label>
                        <v-select v-model="selectedStatus" :options="statusOptions" name="status" :clearable="false" style="width: 200px;" @input="searchBooking"></v-select>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full">
                        <label>Ngày đặt</label>
                        <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'left'"
                    @update="dateRangePicker" v-model="dateRange" class="w-full" >
                </date-range-picker>
                    </div>
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{tr.stt}}
                    </vs-td>

                    <vs-td>
                        {{tr.organizationBranchName}}
                    </vs-td>
                    <vs-td>
                        {{tr.performerName }}
                    </vs-td>

                    <vs-td>
                        {{tr.beautyBookingDetails.length>0  && tr.beautyBookingDetails[0].beautyServicePackage ?  tr.beautyBookingDetails[0].beautyServicePackage.name : null }}
                    </vs-td>

                    <vs-td class="">
                        <vs-chip  class="ag-grid-cell-chip" :color="chipColorCheckBeautyCollectFee(tr.status)">
                            <span>{{ checkBeautyCollectFee(tr.status) }}</span>
                        </vs-chip>
                    </vs-td>

                    <vs-td>
                        {{tr.dateBooking  }}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <div class="vx-row" v-if="beautyBookingData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                    beautyBookingData.length - currentPage * pageSize > 0 ? currentPage *
                        pageSize
                        : beautyBookingData.length
                }} /
                                {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import DateRangePicker from '../../../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import { AgGridVue } from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import CellRendererStatusBooking from './cell-renderer/CellRendererStatusBooking'

export default {
    name: "BookingHistory",
    components: {
        vSelect,
        DateRangePicker,
        AgGridVue,
        CellRendererStatusBooking,
    },
    props: {
        loyaltyCustomerId: {
            default: null,
            type: Number,
        },
    },
    data() {
        return {
            branchOptions: [],
            selectedBranchValue: null,
            beautyServicePackageId:null,
            departmentOptions: [
                { value: null, label: 'Tất cả' }
            ],
            selectedDepartmentValue: null,
            doctorOptions: [
                { value: null, label: 'Tất cả' }
            ],
            selectedDoctorValue: null,
            customerOptions: [
                { value: null, label: 'Tất cả' }
            ],
            selectedCustomerValue: null,
            statusOptions: [
                { value: null, label: 'Tất cả' },
                { value: 0, label: 'Tạo mới' },
                { value: 1, label: 'Thành công' },
                { value: 2, label: 'Lỡ hẹn' },
                { value: 3, label: 'Hủy hẹn' },
                { value: 4, label: 'Đã xác nhận' },
            ],
            selectedstatusValue: null,
            dateRange: {
                startDate: (new Date().setMonth(new Date().getMonth() - 1)),
                // startDate: new Date().setUTCHours(0, 0, 0, 0),
                endDate: new Date().setUTCHours(16, 59, 59, 999)
            },
            beautyBookingData: [],
            groupServiceOptions:[{label:'Tất cả',value:null}],
            // AgGrid
            gridApi: null,
            gridOptions: {},
            pageNumber: 0,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
        }
    },

    computed: {
        selectedBranch: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value == this.selectedBranchValue)),
                    value: this.branchOptions.find(x => x.value == this.selectedBranchValue)
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                if (this.selectedBranchValue) {
                    this.getDepartmentData();
                    this.getDoctorData();
                }
            }
        },
        selectedDepartment: {
            get() {
                return {
                    label: this.getLabelString(this.departmentOptions.find(x => x.value == this.selectedDepartmentValue)),
                    value: this.departmentOptions.find(x => x.value == this.selectedDepartmentValue)
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
                this.getDoctorData();
            }
        },
        selectedDoctor: {
            get() {
                return {
                    label: this.getLabelString(this.doctorOptions.find(x => x.value == this.selectedDoctorValue)),
                    value: this.doctorOptions.find(x => x.value == this.selectedDoctorValue)
                }
            },
            set(obj) {
                this.selectedDoctorValue = obj ? obj.value : null;
            }
        },
        selectedStatus: {
            get() {
                let obj = this.statusOptions.find(x => x.value === this.selectedstatusValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedstatusValue = obj ? obj.value : null;
            }
        },
        checkBeautyCollectFee(){
            return value =>{
                if (value === 0) {
                    return "Tạo mới";
                } else if (value === 1) {
                    return "Thành công"
                } else if (value === 2) {
                    return "Lỡ hẹn"
                } else if (value === 3) {
                    return "Hủy hẹn"
                } else if (value === 4) {
                    return "Đã xác nhận"
                }  
            }
        },
        chipColorCheckBeautyCollectFee(){
            return value =>{
                if (value === 0) {
                    return "primary";
                } else if (value === 1) {
                    return "success"
                } else if (value === 2) {
                    return "warning"
                } else if (value === 3) {
                    return "danger"
                } else if (value === 4) {
                    return "primary"
                } 
            }
        }
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        dateRange(newDateRange) {
            this.searchBooking();  
        }
    },
  

    created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });
        this.branchOptions.unshift({ value: null, label: 'Tất cả' });

        this.getDepartmentData();
        this.getDoctorData();
        this.searchBooking();
    },

    methods: {
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },

        getDepartmentData() {
            return new Promise((resolve, reject) => {
                let body = {
                    organizationBranchId: this.selectedBranchValue,
                }

                this.departmentOptions = [];

                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', body).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.departmentOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName
                            }
                        });
                    }
                    this.departmentOptions.unshift({ value: null, label: 'Tất cả' });
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getDoctorData() {
            return new Promise((resolve, reject) => {
                let url = '/beauty-booking/get-list-doctor-department';
                if (this.selectedBranchValue) {
                    url += '?organizationBranchId=' + this.selectedBranchValue
                }
                if (this.selectedDepartmentValue) {
                    url += '&departmentId=' + this.selectedDepartmentValue
                }

                this.doctorOptions = [];

                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorOptions = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    this.doctorOptions.unshift({ value: null, label: 'Tất cả' })
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setUTCHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setUTCHours(16, 59, 59, 999));
        },

        searchBooking() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let payload = {
                customerId: this.loyaltyCustomerId,
                departmentId: this.selectedDepartmentValue,
                organizationBranchId: this.selectedBranchValue ? this.selectedBranchValue : userInfo.organizationBranchId,
                endDate: new Date(this.dateRange.endDate).toISOString(),
                performerId: this.selectedDoctorValue,
                startDate: new Date(this.dateRange.startDate).toISOString(),
                status: this.selectedstatusValue,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                beautyServicePackageId:this.beautyServicePackageId
            }

            this.$vs.loading();
            this.$crm.post('/beauty-booking/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.beautyBookingData = res.data.content.map(el => {
                        el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1;
                        let branch = this.branchOptions.find(x => x.value == el.organizationBranchId);
                        el.organizationBranchName = branch ? branch.label : null;
                        el.doctorName = el.beautyBookingDetails[0].performer ? el.beautyBookingDetails[0].performer.fullName : null;
                        el.dateBooking = moment(el.beautyBookingDetails[0].bookingDate).format('DD/MM/YYYY') + ' ' + (el.beautyBookingDetails[0].startTime ? el.beautyBookingDetails[0].startTime : '');
                        el.serviceBooking = el.beautyBookingDetails[0].beautyServicePackage ? el.beautyBookingDetails[0].beautyServicePackage.name : el.beautyBookingDetails[0].beautyPackageCombo ? el.beautyBookingDetails[0].beautyPackageCombo.name : null;
                        el.customerName = el.loyaltyCustomer.phoneNumber + ' - ' + el.loyaltyCustomer.fullName;
                        return el;
                    })
                    this.groupServiceOptions = res.data.content.map(el =>{
                        if(el.beautyBookingDetails.length>0  && el.beautyBookingDetails[0].beautyServicePackage){
                            return {
                                value:el.beautyBookingDetails[0].beautyServicePackage.id ,
                                label:el.beautyBookingDetails[0].beautyServicePackage.name 
                                    }
                        }
                    })
                    this.groupServiceOptions.unshift({label:'Tất cả',value:null})
                } else {
                    this.beautyBookingData = [];
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.searchBooking();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.searchBooking();
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style>
.table-custom .vs-table--tbody{
    min-height: 300px;
}
</style>
